module.exports = __webpack_public_path__ + "img/customer_bg.8275afd1.png";